import React from "react";

export function PageHeader({ title, subtitle, children }) {
  return (
    <div className="sticky top-14 lg:top-0 z-20 bg-white/90 backdrop-blur-md border-b border-slate-200 px-4 sm:px-6 lg:px-8 py-3 sm:py-4 flex flex-col sm:flex-row sm:items-center justify-between gap-3">
      <div className="min-w-0">
        <h1 className="font-head text-lg sm:text-xl font-bold text-slate-900 tracking-tight truncate">{title}</h1>
        {subtitle && <p className="text-xs text-slate-500 mt-0.5">{subtitle}</p>}
      </div>
      <div className="flex items-center flex-wrap gap-2">{children}</div>
    </div>
  );
}

export function fmtNum(v) {
  if (v === null || v === undefined || v === "") return "";
  const n = Number(v);
  return Number.isInteger(n) ? n.toLocaleString("id-ID") : n.toLocaleString("id-ID");
}

export function SelisihBadge({ value }) {
  if (value === null || value === undefined) {
    return <span className="text-slate-300 text-xs">–</span>;
  }
  const n = Number(value);
  if (n < 0)
    return (
      <span className="inline-flex items-center rounded-md bg-red-50 border border-red-200 px-2 py-0.5 text-xs font-bold text-red-600 tabular font-mono-t" data-testid="selisih-badge">
        {n}
      </span>
    );
  if (n > 0)
    return (
      <span className="inline-flex items-center rounded-md bg-amber-50 border border-amber-200 px-2 py-0.5 text-xs font-bold text-amber-600 tabular font-mono-t" data-testid="selisih-badge">
        +{n}
      </span>
    );
  return (
    <span className="inline-flex items-center rounded-md bg-emerald-50 border border-emerald-200 px-2 py-0.5 text-xs font-bold text-emerald-600 tabular font-mono-t" data-testid="selisih-badge">
      0
    </span>
  );
}
